// 홈스쿨링 - 본사 - 지사별 통계
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import ReactEcharts from "echarts-for-react";
import { InputGroup } from 'react-bootstrap';

import AgGridReactEx from "@app/components/AgGridReactEx";

import axios from '@app/lib/axios';

import FlyEngConstants from "@app/config/FlyEngConstants";

import flyengStyle from "../../components/style";

import { CardStatActivity } from "../../components/CardStatContent";

const defaultColDef = {
    flex: 1,
};

const listColumn = [
    {
        headerName: "No",
        headerClass: "bg-dark text-light",
        field: "id",
        sortable: false,
        width: 80,
        minWidth: 50,
        resizable: true,
        cellClass: "text-center",
        filter: false,
        valueGetter: "node.rowIndex + 1",
    },
    {
        headerName: "콘텐츠명",
        field: "title",
        cellClass: "text-left",
        minWidth: 135,
    },
    {
        headerName: "카테고리",
        field: "categoryId",
        minWidth: 70,
        cellRenderer: (param) => {
            const category = FlyEngConstants.HOME.CATEGORY.find((c) => c.id === param.value);
            return category ? category.name : "-";
        },
    },
    {
        headerName: "레벨",
        field: "age",
        minWidth: 70,
        cellRenderer: (param) => {
            const level = FlyEngConstants.LEVEL.find((l) => l.age === param.value);
            return level ? `레벨${level.name}` : "-";
        },
    },
    {
        headerName: "메뉴",
        field: "pathName",
        minWidth: 75,
        cellRenderer: (param) => {
            return param.value;
        },
    },
    {
        headerName: "실행수",
        field: "cnt",
        cellRenderer: (param) => {
            return param.value ? param.value.toLocaleString() : "-";
        },
    },
    {
        headerName: "누적 실행수",
        field: "cntSum",
        cellRenderer: (param) => {
            return param.value ? param.value.toLocaleString() : "-";
        },
    },
];

const totalBase = { total: 0, playCountClass: 0, playCount3: 0, playCount4: 0, playCount5: 0, playCount6: 0, playCountClassSum: 0, playCount3Sum: 0, playCount4Sum: 0, playCount5Sum: 0, playCount6Sum: 0 };
const Activity = forwardRef(({ statPeriod }, ref) => {
    const [loadingData, setLoadingData] = useState(false);
    const [total, setTotal] = useState(totalBase);
    const [stat, setStat] = useState(false);
    const [statContent, setStatContent] = useState(false);
    const [statContentSum, setStatContentSum] = useState(false);
    const [tableData, setTableData] = useState(false);
    const [searchParam, setSearchParam] = useState({
        type: "title",
        value: "",
    });

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            const excelData = {
                fileName: "플라잉홈_콘텐츠통계",
                sheets: [
                    {
                        name: "콘텐츠",
                        title: "콘텐츠 통계",
                        columnTitle: ["콘텐츠명", "카테고리", "레벨", "메뉴", "순 실행 수", "누적 실행 수"],
                        data: stat
                            ? stat.map((s) => [
                                  s.title,
                                  s.categoryName,
                                  s.ageName,
                                  s.pathName,
                                  s.cnt,
                                  s.cntSum,
                              ])
                            : [],
                    },
                ],
            };
            callback(null, excelData);
        },
    }));

    const getStat = useCallback(
        () => {
            setLoadingData(true);
            setStat(null);
            setTableData(null);
            axios({
                method: "POST",
                url: `/api/flyeng_stat/new/home/activity`,
                data: {
                    startDate: statPeriod.startDate,
                    endDate: statPeriod.endDate,
                    periodType: statPeriod.type,
                    page: 0,
                    limit: -1,
                },
            })
                .then((result) => {
                    if (result.data.code === 200) {
                        const stat = result.data.data.list;
                        const total = {...totalBase};
                        const statContent = [
                                { id: "playCountClass", name: "교실영어(순)", value: 0 },
                                { id: "playCount3", name: "영상(순)", value: 0 },
                                { id: "playCount4", name: "동화(순)", value: 0 },
                                { id: "playCount5", name: "액티비티(순)", value: 0 },
                                { id: "playCount6", name: "AI(순)", value: 0 },
                            ],
                            statContentSum = [
                                { id: "playCountClassSum", name: "교실영어(누적)", value: 0 },
                                { id: "playCount3Sum", name: "영상(누적)", value: 0 },
                                { id: "playCount4Sum", name: "동화(누적)", value: 0 },
                                { id: "playCount5Sum", name: "액티비티(누적)", value: 0 },
                                { id: "playCount6Sum", name: "AI(누적)", value: 0 },
                            ];
                        stat.forEach((s) => {
                            let execPath = null;
                            for (let i = 0; i < FlyEngConstants.HOME.EXECUTE_PATH.length; i++) {
                                execPath = FlyEngConstants.HOME.EXECUTE_PATH[i].sub.find((sub) => sub.path == s.path);
                                if (execPath) {
                                    s.pathName = execPath.name;
                                    break;
                                }
                            }
                            total.playCountClass += (s.categoryId == 0 && s.cnt) || 0;
                            total.playCount3 += (s.categoryId == 3 && s.cnt) || 0;
                            total.playCount4 += (s.categoryId == 4 && s.cnt) || 0;
                            total.playCount5 += (s.categoryId == 5 && s.cnt) || 0;
                            total.playCount6 += (s.categoryId == 6 && s.cnt) || 0;
                            total.playCountClassSum += (s.categoryId == 0 && s.cntSum) || 0;
                            total.playCount3Sum += (s.categoryId == 3 && s.cntSum) || 0;
                            total.playCount4Sum += (s.categoryId == 4 && s.cntSum) || 0;
                            total.playCount5Sum += (s.categoryId == 5 && s.cntSum) || 0;
                            total.playCount6Sum += (s.categoryId == 6 && s.cntSum) || 0;
                        });
                        total.total = stat.length;

                        statContent.forEach((s) => (s.value = total[s.id]));
                        statContentSum.forEach((s) => (s.value = total[s.id]));

                        setStat(stat);
                        setTotal(total);
                        setStatContent(statContent);
                        setStatContentSum(statContentSum);
                        applyData(searchParam, stat);
                    } else {
                        alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                    }
                    setLoadingData(false);
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");

                    setLoadingData(false);
                });
        },
        [statPeriod]
    );
    useEffect(() => {
        getStat();
        return () => {};
    }, [getStat]);
        
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            onSearch();
        }
    };
    const onSearch = () => {
        applyData(searchParam, stat);
    }
        
    const applyData = (searchParam, list) => {
        var tableData = listSearch(searchParam, list);

        setTableData(tableData);
        setSearchParam(searchParam);
    }

    const listSearch = (searchParam, list) => {
        let tableDataNew = [];
        if(!searchParam.value) {
            tableDataNew = list;
        } else {
            let filters = null;
            if(searchParam.type == 'categoryId') {
                filters = FlyEngConstants.HOME.CATEGORY.filter((c) => c.name.indexOf(searchParam.value) >= 0);
            } else if(searchParam.type == 'age') {
                const age = searchParam.value.toLowerCase().charCodeAt(0) - 97;
                filters = [{id: age}];
            }
            list.forEach(item => {
                if(filters) {
                    filters.forEach((f) => {
                        if (item[searchParam.type] === f.id) {
                            if(tableDataNew.findIndex((d) => d.activityId == item.activityId) == -1) {
                                tableDataNew.push(item);
                            }
                        }
                    });
                } else {
                    if (item[searchParam.type] && item[searchParam.type].indexOf(searchParam.value) >= 0) {
                        if(tableDataNew.findIndex((d) => d.activityId == item.activityId) == -1) {
                            tableDataNew.push(item);
                        }
                    }
                }
            });
        }
        return tableDataNew;
    }

    const optionContent = {
        tooltip: {
            trigger: "item",
            formatter: (param) => {
                return param.data ? param.data.name + " : " + param.data.value.toLocaleString() + " (" + Math.ceil(param.percent) + "%)" : "";
            },
        },
        series: [
            {
                type: "pie",
                data: statContent,
                radius: ["0%", "35%"],
                animation: false,
                center: ["20%", "50%"],
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                    position: "center",
                },
            },
            {
                type: "pie",
                data: statContentSum,
                radius: ["40%", "75%"],
                center: ["20%", "50%"],
                animation: false,
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                    position: "center",
                },
            },
        ],
        legend: [{
            show: true,
            data: flyengStyle.seriesHomePlayChart.map((s) => s.name + '(순)'),
            y: "bottom",
            orient: "vertical",
            align: "left",
            right: 170,
            formatter: (name) => {
                let s = statContent.find((s) => s.name === name);
                if (s) {
                    return `${name} - ${s.value ? s.value.toLocaleString() : 0}`;
                }
                return null;
            },
        }, {
            show: true,
            data: flyengStyle.seriesHomePlaySumChart.map((s) => s.name + '(누적)'),
            x: "right",
            y: "bottom",
            orient: "vertical",
            align: "left",
            formatter: (name) => {
                
                const s = statContentSum.find((s) => s.name === name);
                if (s) {
                    return `${name} - ${s.value ? s.value.toLocaleString() : 0}`;
                }
                return null;
            },
        }],
        color: flyengStyle.seriesHomeColor.pale.concat(flyengStyle.seriesHomeColor.normal),
    };

    return (
        <div className="stat-branch-content">
            <div className="row mb-3">
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="row mb-3">
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                            <CardStatActivity id="1" title={`교실영어`} total={total.playCountClass} totalSum={total.playCountClassSum} titleBgClass="bg-tomonote" />
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                            <CardStatActivity id="2" title={`영상`} total={total.playCount3} totalSum={total.playCount3Sum} titleBgClass="bg-tomonote" />
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                            <CardStatActivity id="2" title={`동화`} total={total.playCount4} totalSum={total.playCount4Sum} titleBgClass="bg-tomonote" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <CardStatActivity id="2" title={`액티비티`} total={total.playCount5} totalSum={total.playCount5Sum} titleBgClass="bg-tomonote" />
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <CardStatActivity id="2" title={`AI`} total={total.playCount6} totalSum={total.playCount6Sum} titleBgClass="bg-tomonote" />
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 h-100">
                    <div className="row">
                        <div className="col">
                            <ReactEcharts theme="macarons" option={optionContent} style={{ height: `250px` }} />
                        </div>
                    </div>
                </div>
            </div>
                <div className="row mb-1">
                    <div className="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12 pl-4 d-flex">
                        <h5 className="mb-0" style={{alignSelf: "end"}}>
                            <span>
                                {tableData ? tableData.length.toLocaleString() : '0'} / {total ? total.total.toLocaleString() : '0'}
                            </span>
                        </h5>
                    </div>
                    <div className="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                        <InputGroup className="input-group my-group">
                            <select
                                className="form-control input-group-append"
                                title="검색 항목 선택"
                                style={{ height: "auto", maxWidth: "120px" }}
                                value={searchParam.type}
                                onChange={(e) => {
                                    const param = { ...searchParam };
                                    param.type = e.target.value;
                                    setSearchParam(param);
                                }}
                            >
                                <option value="title" defaultChecked>콘텐츠</option>
                                <option value="categoryId">카테고리</option>
                                <option value="age">레벨(A/B/C/D)</option>
                            </select>
                            <input
                                className="form-control"
                                type="text"
                                value={searchParam.value}
                                placeholder="콘텐츠명 | 카테고리 | 레벨(A/B/C/D)"
                                onChange={(e) => {
                                    const param = { ...searchParam };
                                    param.value = e.target.value;
                                    setSearchParam(param);
                                }}
                                onKeyPress={handleKeyPress}
                            />
                            <InputGroup.Append>
                                <input type="submit" className="btn btn-primary" value="검색" onClick={onSearch} />
                            </InputGroup.Append>
                        </InputGroup>
                    </div>
                </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <AgGridReactEx
                        defaultColDef={defaultColDef}
                        columnDefs={listColumn}
                        rowData={tableData}
                        pagination={true}
                        overlayNoRowsTemplate={`<span>통계 자료가 없습니다.</span>`}
                    />
                </div>
            </div>
        </div>
    );
});

export default Activity;
